<template>
    <SalesReportTemplate
        title="Sales End of Day"
        :columns="columns"
        fetchRoute="/reports/sales-end-of-day"
        :reportTypeCode="REPORT_MASTER_CODES.SALES_END_OF_DAY"
        :permission="PERMISSION_CODES.CMS_VIEW_REPORT_END_OF_DAY"
        @onResponse="handleResponse"
    >
        <div class="my-3 gy-3 gx-2 row" v-if="stats">
            <div class="col-sm-4 col-md-3">
                <Card sm title="Total Sales ($)">
                    <TitleBySideItem sm title="Gift Cards"> ${{ stats.totalSales.giftCardTotal }} </TitleBySideItem>
                    <TitleBySideItem sm title="Subtotal">${{ stats.totalSales.subTotalWithoutGiftCard }}</TitleBySideItem>
                    <TitleBySideItem sm title="Total Tax">${{ stats.totalSales.totalTax }}</TitleBySideItem>
                    <TitleBySideItem sm title="Total Invoiced">${{ stats.totalSales.totalInvoiced }}</TitleBySideItem>
                </Card>
            </div>
            <div class="col-sm-4 col-md-3">
                <Card sm title="Average Spent">
                    <TitleBySideItem sm title="Transaction Average">${{ stats.averageSpent.transactionAverage }}</TitleBySideItem>
                </Card>
            </div>
            <div class="col-sm-4 col-md-3">
                <Card sm title="Discounts">
                    <TitleBySideItem sm title="Total Discount">-${{ stats.discounts.totalDiscount }}</TitleBySideItem>
                    <TitleBySideItem sm title="Loyalty Redemptions">-${{ stats.discounts.loyaltyRedemptions }}</TitleBySideItem>
                </Card>
            </div>
            <div class="col-sm-4 col-md-3">
                <Card sm title="Cost/Profit">
                    <TitleBySideItem sm title="Total Cost">${{ stats.costProfit.totalCost }}</TitleBySideItem>
                    <TitleBySideItem sm title="Gross Profit">${{ stats.costProfit.totalProfit }}</TitleBySideItem>
                </Card>
            </div>
            <div class="col-sm-4 col-md-3">
                <Card sm title="Payment Methods">
                    <TitleBySideItem
                        sm
                        :title="paymentMethod.title"
                        v-for="paymentMethod of stats.paymentMethods"
                        :key="paymentMethod.title"
                        >${{ paymentMethod.amount }}</TitleBySideItem
                    >
                </Card>
            </div>
            <div class="col-sm-4 col-md-3">
                <Card sm title="Taxes">
                    <TitleBySideItem sm title="Canada HST">${{ stats.taxes.canadaHst }}</TitleBySideItem>
                    <TitleBySideItem sm title="Ontario Tax Rate">${{ stats.taxes.ontarioTaxRate }}</TitleBySideItem>
                </Card>
            </div>
            <div class="col-sm-4 col-md-3">
                <Card sm title="Invoices Sold">
                    <TitleBySideItem sm title="Invoices Sold">{{ stats.invoicesSold.invoicesSold }}</TitleBySideItem>
                    <TitleBySideItem sm title="Invoices Refunded">{{ stats.invoicesSold.invoicesRefunded }}</TitleBySideItem>
                    <TitleBySideItem sm title="Net Sold">{{ stats.invoicesSold.netSold }}</TitleBySideItem>
                </Card>
            </div>
            <div class="col-sm-4 col-md-3">
                <Card sm title="Products Sold">
                    <TitleBySideItem sm title="Items Sold">{{ stats.productsSold.itemSold }}</TitleBySideItem>
                    <TitleBySideItem sm title="Items Refunded">{{ stats.productsSold.itemsRefunded }}</TitleBySideItem>
                    <TitleBySideItem sm title="Net Sold">{{ stats.productsSold.netSold }}</TitleBySideItem>
                </Card>
            </div>
        </div>
    </SalesReportTemplate>
</template>

<script>
import { mapState } from "vuex"
import { /* baseURL, http, serverURL */ } from "../../../utils/http"
import Card from "../../UI/Card.vue"
import TitleBySideItem from "../../UI/TitleBySideItem.vue"
import SalesReportTemplate from "./SalesReportTemplate.vue"
import { PERMISSION_CODES } from "../../../store/permission"

export default {
    components: { TitleBySideItem, SalesReportTemplate, Card },
    data() {
        return {
            result: null,
            PERMISSION_CODES,
            stats: null,
            columns: [
                {
                    title: "Employee",
                    key: "employee_name",
                },
                {
                    title: "Total Invoiced",
                    key: "total_invoiced",
                },
                {
                    title: "Sales ($)",
                    key: "sales_total",
                },
                {
                    title: "Sales (#)",
                    key: "sales_number",
                },
                {
                    title: "Average Sale",
                    key: "sales_average",
                },
                {
                    title: "Refunds ($)",
                    key: "refund_total",
                },
                {
                    title: "Refunds (#)",
                    key: "refund_number",
                },
                {
                    title: "Average Refund",
                    key: "refund_average",
                },
            ],
            filterQuery: {},
            
        }
    },
    computed: {
        ...mapState("misc", ["REPORT_MASTER_CODES"]),
    },
    methods: {
        handleResponse(result) {
            this.result = result.result
            this.stats = result.stats
            this.filterQuery = result.filterQuery
        },
    },
}
</script>

<style></style>
